import React, { useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { Input, Button, Alert, Form } from "@intech/web-ui";

import { BaseAuth } from "../Base";
import { AuthService } from "@services";
import { LoginEntidade } from "@entidades";

import { Checkbox } from "./Checkbox";
import { CheckboxContainer, CheckboxTitle } from "./styles";
import { parse } from "date-fns";

export const EsqueciSenha: React.FC = () => {
  const history = useHistory();

  const [cpf, setCpf] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [enviarEmail, setEnviarEmail] = useState(true);
  const [enviarSms, setEnviarSms] = useState(false);

  const [Erros, setErros] = useState(null);

  const form = useRef<Form>(null);

  async function enviarSenha() {
    setErros("");

    if (form.current?.validate()) {
      try {
        const user: LoginEntidade = {
          Cpf: cpf,
          DataNascimento: parse(dataNascimento, "dd/MM/yyyy", new Date())
        };

        const resultado = await AuthService.CriarAcesso(
          user,
          enviarSms,
          enviarEmail
        );

        window.alert(resultado);
        history.push("/login");
      } catch (e) {
        const err: any = e;
        const message = err.response ? err.response.data : err;
        console.log(message);
        setErros(message);
      }
    }
  }

  function toggleSms() {
    setEnviarSms(true);
    setEnviarEmail(false);
  }

  function toggleEmail() {
    setEnviarSms(false);
    setEnviarEmail(true);
  }

  return (
    <BaseAuth>
      <h5>
        <b>Esqueci minha senha / Primeiro Acesso</b>
        <br />
        <br />
        <small>
          Preencha as informações para que possamos gerar uma senha que será
          enviada para seu email cadastrado na Regius.
        </small>
      </h5>

      <Form ref={form}>
        <Input
          max={11}
          value={cpf}
          onChange={setCpf}
          placeholder="CPF (somente números)"
          required
        />

        <Input
          value={dataNascimento}
          onChange={setDataNascimento}
          placeholder={"Data de Nascimento"}
          type={"date"}
          required
        />

        <CheckboxTitle>Enviar nova senha por:</CheckboxTitle>
        <CheckboxContainer>
          <Checkbox
            title={"E-mail"}
            active={enviarEmail}
            onClick={toggleEmail}
          />
          <Checkbox title={"SMS"} active={enviarSms} onClick={toggleSms} />
        </CheckboxContainer>

        <Button
          title={"Enviar Nova Senha"}
          type={"primary"}
          usesLoading
          loadingText="Carregando..."
          block
          submit
          onClick={enviarSenha}
        />

        <Link className="btn btn-default btn-block" to="/login">
          Voltar para a página de Login
        </Link>
        <br />

        <Alert type={"danger"}>{Erros}</Alert>
      </Form>
    </BaseAuth>
  );
};
